import React from 'react';
import bindMethods from 'yaab';

import Microbit from './utils/microbit';
import MicrobitDevice from './components/Microbit/Microbit';

import StyledApp, { Intro, Logo } from './App.styles';

import Button from './components/Button/Button';
import LogoImg from './media/logo.svg';

class App extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			accelerometer: {
				x: 0,
				y: 0,
				z: 0,
			},
			connected: false,
		};

		bindMethods(this);
		
		this.microbit = new Microbit({
			accelerometer: this.handleAccelerometer,
			onConnect: this.onConnect,
			onDisconnect: this.onDisconnect,
		});
	}

	connect() {
		this.microbit.searchDevice();
	}

	onConnect() {
		this.setState({
			connected: true,
		});
	}

	onDisconnect() {
		this.setState({
			connected: false,
		});
	}

	handleAccelerometer({x, y, z}) {
		x = x / 1000;
		y = y / 1000;
		z = z / 1000;
		const radians = 180 / Math.PI;
		const pitch = Math.atan(x / Math.sqrt(Math.pow(y, 2) + Math.pow(z, 2))) * radians;
		const roll = -1 * Math.atan(y, Math.sqrt(Math.pow(x, 2) + Math.pow(z, 2))) * radians;

		this.setState({
			accelerometer: {
				x,
				y,
				z,
				roll,
				pitch,
			},
		});
	}

	render() {
		const { accelerometer, connected } = this.state;
		return (
			<StyledApp>
				{!connected && <Intro>
					<p>This is a demo to accessing the accelerometer data from the micro:bit over bluetooth.</p>
					<p>Currently only Chrome on Android, Chrome OS and Mac support web bluetooth.</p>
					<p>The micro:bit is currently unconnected, click the connect button to begin demo.</p>
					<Button onClick={this.connect}>Connect micro:bit</Button>
				</Intro>}
				<MicrobitDevice accelerometer={accelerometer} />
				<a href="https://helenlawes.co.uk/article/micro-bluetooth"><Logo src={LogoImg} alt="Helen Lawes - Web developer" /></a>
			</StyledApp>
		);
	}
}

App.description = `
	
`;

export default App;



// WEBPACK FOOTER //
// ./src/App.js